import * as React from "react";
import * as ReactDOM from "react-dom";
import "./styles/default.scss";
import App from "./app/App";
import httpClient from "./services/httpClient";
import { appPathForRole } from "./routes";

const rootElement = document.getElementById("root");
if (rootElement) {
  // If already authenticated, redirect to app based on role

  const role =
    (httpClient.jwt as any)?.role ||
    (httpClient.jwt as any)?.userRole ||
    (httpClient.jwt as any)?.role_name;

  let target = appPathForRole(role);

  // Si l'utilisateur vient d'un lien de test (return_to_test), le rediriger vers l'apprenant
  // pour passer le test, peu importe son rôle actuel
  const urlParams = new URLSearchParams(window.location.search);
  const fromTest = urlParams.get("return_to_test");

  if (fromTest && httpClient.rawJwt) {
    target = `/apprenant?from_test=${encodeURIComponent(fromTest)}`;
  }

  if (httpClient.rawJwt && target && target !== "/") {
    window.location.assign(target);
  } else {
    ReactDOM.render(<App />, rootElement);
  }
}
